module.exports = __webpack_public_path__ + "static/media/questionnaire-step3.72c3ef46.png";